import { isReservedBusinessSlug } from '../../util/businessSlug';
export const BOOKING_APPEARANCE_KEY = 'timely-booking-appearance';
export const normalizeBookingAppearance = value => ['light', 'dark', 'system'].includes(value) ? value : 'system';
export function isPublicBookingPath(pathname) {
  const parts = pathname.split('/').filter(Boolean);
  if (!parts.length) return false;
  if (parts[0] === 'booking' && parts[1] === 'payment') return true;
  if (parts[0] === 'book' && parts[1] === 'embed') return true;
  if (parts[0] === 'embed') return true;
  if (parts[0] === 'b') return !!parts[1] && !isReservedBusinessSlug(parts[1]);
  return !isReservedBusinessSlug(parts[0]);
}
export function resolveBookingMode(preference, systemDark) {
  const value = normalizeBookingAppearance(preference);
  return value === 'system' ? (systemDark ? 'dark' : 'light') : value;
}
